import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const useSuccessToast = (mutation, key = null) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (mutation.loading === false && mutation.success === true) {
      toast({
        title: "Success",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      if (key) queryClient.invalidateQueries(key);
    }
  }, [mutation.loading]);
};

export const useErrorToast = (mutation) => {
  const toast = useToast();
  useEffect(() => {
    if (
      mutation.loading === false &&
      mutation.error &&
      mutation.success === false
    ) {
      const customError = checkError(mutation.error);
      toast({
        title: customError,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [mutation.loading]);
};
const checkError = (error) => {
  if (error == "bla") return "ewfwefwef";
  else return error;
};
